import { config } from "../../../../../config";
import http from "../../../../../http";
import { GET_REASON_BEGIN, GET_REASON_SUCCESS } from "./type";
import { hasErrors } from "../../../error/actions";

export const getReason = () => {
    return async dispatch => {
        try {
            dispatch(getBegin())
            const result = await http.get(config.api.COMMON.TITLE_REASON.GET_REASONS)
            dispatch(getSuccess(result))
        } catch (error) {
            dispatch(hasErrors(error))
        }
    }
}

const getBegin = () => {
    return dispatch => {
        dispatch({ type: GET_REASON_BEGIN })
    }
}
const getSuccess = (items) => {
    return dispatch => {
        dispatch({ type: GET_REASON_SUCCESS, payload: { items, loading: false } })
    }
}